module.exports = __webpack_public_path__ + "media/subway/A-545245bd.png";